export const normalizeStringForSearch = (str: string) => {
    return (
        str
            ?.trim()
            ?.normalize('NFD')
            ?.toLowerCase()
            ?.replace(/[\u0300-\u036f]/g, '') || ''
    );
};
